import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../common/customHttp.service';
import { ApiUrl } from '../../common/apiUrls';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../layout/layout.component';
import { PagerService } from '../../common/pagerService';
import 'rxjs/add/operator/map';
import { KpiSearchFields } from '../../common/viewModels/Reports/KpiModel';
import { CustomerModel } from '../../common/viewModels/Admin/CustomerModel';
import { FormatService } from '../../common/formatService';

@Component({
    selector: 'kpi',
    templateUrl: './kpi.component.html',
    styleUrls: ['./kpi.component.scss']
})
export class KPIComponent implements OnInit {
    searchForm: FormGroup;
    searchFields: KpiSearchFields = new KpiSearchFields();
    id: number;
    isNoRecords: boolean = true;
    pager: any = {};
    pagedItems: any[];
    length: number = 0;
    name: any;
    customers: CustomerModel[];
    labs: any;
    pageSize: number = 10;
    isShowSelectOption: boolean = true;

    constructor(public _router: Router, private _formBuilder: FormBuilder,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute, private _pagerService: PagerService,
        private _mApp: MainAppComponent, private _toastrService: ToastrService, private _formatService: FormatService) {
    }

    ngOnInit() {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
        this.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
        this.pager.pageSize = this.pageSize;
        this.pager.pageIndex = 0;
        this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
        this.createSearchForm();
        if (curUserDetails && curUserDetails.LabIds && curUserDetails.UserTypeId == 2) {
            this.searchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
        }
        if (curUserDetails && curUserDetails.DefaultCompanyId) {
            this.searchForm.controls['CustomerId'].setValue(parseInt(curUserDetails.DefaultCompanyId));
        }
        if(curUserDetails && curUserDetails.RoleId == 9 && curUserDetails.UserTypeId == 3){
            this.isShowSelectOption = false;
        }
        this.GetCustomers();
        this.GetLabs();
        this.BindStaticSearchData();
        this.setPage(this.pager);
    }

    createSearchForm() {
        this.searchForm = this._formBuilder.group({
            CustomerId: [''],
            LabIds: [''],
            ReceivedDateFrom: [null],
            ReceivedDateTo: [null],
            LabName: [''],
        });
    }

    setPage(page: any) {
        this.pager.pageSize = page.pageSize;
        this.pager.pageIndex = page.pageIndex;
        this.GetKpiList(this.pager);
    }

    BindStaticSearchData() {
        this.searchFields.PageNo = 0;
        this.searchFields.PageSize = this._pagerService.globalPageSize;
    }

    GetCustomers() {
        this._http.get(this._appUrl.GetCustomersMinInfoList)
            .subscribe(
                data => {
                    this.customers = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json().Result, '')
                }
            )
    }

    GetLabs() {
        this._http.get(this._appUrl.GetLabsMinInfoList)
            .subscribe(
                data => {
                    if(this._mApp.userTypeId == 2) {
                        let lstLabs = data.json().Result;
                        if (this._mApp.currentUserLabIds && lstLabs)
                        lstLabs = lstLabs.filter(m => this._mApp.currentUserLabIds.includes(m.LabId));
                        this.labs = lstLabs;
                    }
                    else {
                        this.labs = data.json().Result;
                    }
                },
                error => {
                    this._toastrService.error(error.json())
                }
            )
    }

    GetKpiList(page: any) {
        this._mApp.ShowLoader();
        this.searchFields.PageNo = page.pageIndex;
        this.searchFields.PageSize = page.pageSize
        this._mApp.ShowLoader();
        this._http.post(this._appUrl.GetSampleTurnAroundTimeList, this.searchFields)
            .subscribe(
                res => {

                    this._mApp.HideLoader();
                    var data = res.json();
                    this.length = data.PageResult.TotalRecords;
                    this.pagedItems = data.Result;
                    this.isNoRecords = !(data.Result.length > 0);
                    this._mApp.HideLoader();
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    onSubmit() {
        this.pager.pageIndex = 0;
        let searchDto = this.searchForm.value;
        this.searchFields.CustomerId = searchDto.CustomerId;
        this.searchFields.LabIds = searchDto.LabIds;
        this.searchFields.ReceivedDateFrom = this._formatService.formatDate(searchDto.ReceivedDateFrom);
        this.searchFields.ReceivedDateTo = this._formatService.formatDate(searchDto.ReceivedDateTo);
        this.searchFields.LabName = searchDto.LabName;
        this.setPage(this.pager);
    }

    OnReset() {
        this.searchForm.reset();
        this.pager.pageSize = this._mApp.pageSize;
        this.pager.pageIndex = 0;
        this.searchFields.CustomerId = this._mApp.currentUserDefaultCompanyId ? parseInt(this._mApp.currentUserDefaultCompanyId) : 0;
        // this.searchFields.LabIds = this._mApp.currentUserLabIds ? this._mApp.currentUserLabIds : [];
         this.searchFields.LabIds = [];
        this.searchFields.ReceivedDateFrom = '';
        this.searchFields.ReceivedDateTo = '';
        this.searchFields.LabName = '';
         
        // this.searchForm.controls['LabIds'].setValue(this._mApp.currentUserLabIds ? this._mApp.currentUserLabIds : []);
        this.searchForm.controls['CustomerId'].setValue(this._mApp.currentUserDefaultCompanyId ? parseInt(this._mApp.currentUserDefaultCompanyId) : 0);
        this.GetCustomers();
        this.setPage(this.pager);
        if (this._mApp.userTypeId == 2) {
            var currentUser = JSON.parse(localStorage.getItem('currentUser'));
            let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
            this.searchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
        }
    }

    ExportSampStatExcel() {

        this._mApp.ShowLoader();
        this.onSubmit();
        this.searchFields.IsForExcel = true;
        this._http.post(this._appUrl.ExportSTTExcel, this.searchFields)
            .subscribe(
                res => {
                    this._mApp.HideLoader();
                    window.open(res.json().Result, '_blank');
                    this.searchFields.IsForExcel = false;
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

}
